import { resolveSSOLink } from "../../../../utils/ssoLinkStrategyResolver";

export const resolveLinkHandler = (_, data) => {
  if (!data?.link) {
    return;
  }
  const link = resolveSSOLink(data?.type, data?.link);
  window?.open(link);
};
